import { BRAND_COLORS, GRAY_COLORS } from '../globalTheme';

export const theme = {
	tabMenu: {
		fontFamily: 'Inter, sans-serif',
		container: {
			width: '100%',
			overflow: 'hidden'
		},
		header: {
			borderBottom: `1px solid ${GRAY_COLORS.gray300}`,
			display: 'flex',
			overflowX: 'scroll',
			msOverflowStyle: 'none',
			scrollbarWidth: 'none',
			'&::-webkit-scrollbar': {
				display: 'none'
			}
		},
		button: {
			default: {
				padding: '10px 20px',
				fontSize: '16px',
				fontWeight: 500,
				color: GRAY_COLORS.gray600,
				whiteSpace: 'nowrap',
				flexShrink: 0,
				border: 'none',
				background: 'none',
				cursor: 'pointer',
				transition: 'color 0.3s ease'
			},
			hover: {
				color: BRAND_COLORS.brand600,
				cursor: 'pointer'
			},
			active: {
				color: BRAND_COLORS.brand600,
				position: 'relative' as const,
				cursor: 'pointer',
				fontWeight: 600
			},
			disabled: {
				color: GRAY_COLORS.gray400,
				cursor: 'not-allowed'
			}
		},
		badge: {
			backgroundColor: GRAY_COLORS.gray200,
			borderRadius: '12px',
			color: GRAY_COLORS.gray700,
			width: '24px',
			fontSize: '12px',
			padding: '2px 6px',
			marginLeft: '8px',
			display: 'inline-block'
		},
		activeIndicator: {
			height: '2px',
			backgroundColor: BRAND_COLORS.brand600,
			position: 'absolute',
			bottom: '-1px',
			left: 0,
			right: 0
		},
		content: {
			padding: '2px'
		}
	}
};

export type Theme = typeof theme;
